module.exports = __webpack_public_path__ + "img/10551385_S.e92547de.png";